import { EventEmitter, Injectable } from '@angular/core';
import { HttpService } from '../../shared/services/http.service';
import { LogService } from '../../shared/services/log.service';
import { StepperBuilderService } from "../../avisDePub/creer/services/stepper.builder.service";
import { environment } from "../../../../environments/environment";
import { AnnouncerResponse } from '../common/models/annoouncerResponse';

@Injectable({
	providedIn: 'root'
})
export class AnnouncerApiService {

	private LOG: LogService = new LogService(AnnouncerApiService);

	public AnnouncerResponse: EventEmitter<AnnouncerResponse> = new EventEmitter();

	constructor(private http: HttpService, private stepperBuilderService: StepperBuilderService) {
	}

  public validate(form: any) {
    if (environment.check_announcer === 'false' /*PRB0053306 commenter : || !this.stepperBuilderService.formulaire.toString().includes('E_FORM_')
		  --> et rajouter ce test pour ne pas surcharger le réseau de test inutile*/
      || form.value['_SepSep_idAnnonceur_SepAtt_idannonceurboampweb'] === undefined
      || form.value['_SepSep_idAnnonceur_SepAtt_mailcontactboampweb'] === undefined) {
      this.AnnouncerResponse.emit(null);
      this.AnnouncerResponse.complete();
      return;
    }
    const dataAnnouncer = {
      'announcerLogin': form.value['_SepSep_idAnnonceur_SepAtt_idannonceurboampweb'],
      'announcerMail': form.value['_SepSep_idAnnonceur_SepAtt_mailcontactboampweb'],
      'formCode': this.stepperBuilderService.formulaire.toString()
    };
    this.checkAnnouncerLogin(dataAnnouncer);
  }

	checkAnnouncerLogin(dataAnnouncer: any) {
		const endpoint = '/announcer';
		return this.http.post(endpoint, dataAnnouncer, AnnouncerResponse)
			.subscribe(
				(data) => {
					if (data.status == "KO") {
						this.stepperBuilderService.addStepFieldsOnErrors('_STEP_ID_SepSep_idAnnonceur', '', data.error.toString());
					}
					this.AnnouncerResponse.emit(null);
					this.AnnouncerResponse.complete();
					return;
				},
				(error) => {
					this.LOG.error('Appel back check annonceur KO : ', error);
					return false;
				}
			);
	}
}
